<template>
    <div v-cloak>
        <el-steps :active="3" align-center>
            <el-step title="选择模板" description="请选择需要的操作">
            </el-step>
            <el-step title="上传文件" description="请上传excel、csv文件">

            </el-step>
            <el-step title="校验数据" description="请核对需要导入的数据">

            </el-step>
            <el-step title="查看结果" description="请查看结果和处理错误数据">

            </el-step>
        </el-steps>
        <div class="main">
            <el-row>
                <div style="min-height:200px;max-height:600px;margin-top:5px;overflow: auto;">
                    <table class="ImportExcelTable">
                        <thead>
                        <tr>
                            <th style="min-width: 40px;width:40px">序号</th>
                            <th style="min-width: 80px;max-width: 100px;width:80px">创建时间</th>
                            <th v-for="(p,index) in ImportConfig" v-bind:key="index">{{p.name}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item,index) in items" v-bind:key="index" v-if="index<limit">
                            <td style="min-width: 40px;width:40px;text-align: center;">
                                <span>{{index+1}}</span>
                            </td>
                            <td style="min-width: 80px;width:80px;text-align: center;">
                                <span>{{item.created}}</span>
                            </td>
                            <td v-for="(p,index) in ImportConfig" v-bind:key="index">
                                {{item[p.field]}}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </el-row>
            <div class="grid-content">
                <span v-if="totalCount>limit">当前显示:<span style="font-size: 18px">{{limit}}/{{totalCount}}</span>,<el-button type="text" @click="limit=totalCount">全部展示</el-button></span>
            </div>
            <el-row class="button" v-if="!importDialog">
                <el-button type="primary" size="mini" @click="laststep()">上一步</el-button>
                <el-button type="primary" size="mini" @click="commit()">完成</el-button>
            </el-row>
        </div>
    </div>
</template>

<script>
  import DataStore from './data.store'
export default {
    name: 'step4',
    data: function () {
        return{
            items: [], // 数据对象
            ImportConfig: DataStore.pubdataImportconfig.field,
            totalCount: 0,
            limit: 200
        };
    },
    created: function () {
        this.queryItem();
    }, // 创建时触发
    watch: {}, // 监控变量变动
    props: {
      importDialog: {type: Boolean, default: false},
      context: Object
	},
    methods: {
        async queryItem () {
            var txt = '[{"id":"created_1","property":"created","value":"' + DataStore.tmpDataImportData + '","operator":">=","type":"date"}]';
            try{
            const data = await this.context.$http.post(DataStore.pubdataImportconfig.queryurl, {
                page: 1,
                rows: 900000,
                pageFlag: false,
                totalFlag: false,
                oauthFlag: false,
                oauth: 'ALL',
                filtersRaw: txt,
                sort: 'created',
                order: 'desc'
            }, true);
            if(data.success){
                this.items = data.rows;
                this.totalCount=data.rows.length;
            }else{
                this.$nav.error('查询信息失败:' + data.result);

            }
}catch (e) {
                this.$nav.error('请求出现错误:' + e);

            }

        },

        /**
             * 下一步
             */
        laststep: function () {
            // gotoContentPage(appCtx.cdnPath + '/linkcrm/public_data_management/step3.html');
            this.$nav.push('/modules/crm/public_data_management/public_data_manage/step3.vue');
        },

        /**
             * 到继续导入页面
             */
        commit: function () {
            // gotoContentPage(appCtx.cdnPath + '/linkcrm/public_data_management/step1.html');
            this.$nav.push('/modules/crm/public_data_management/public_data_manage/step1.vue');
        }

    }
};
</script>

<style scoped>
    body {
        background: #ffffff;
    }

    .main .button {
        margin-top: 30px;
        vertical-align: middle;
        text-align: center;

    }

    button {
        border-radius: 0 !important;
    }

    [v-cloak] {
        display: none;
    }

    .ImportExcelTable {
        border-collapse: collapse;
        margin-top: 10px;

    }

    .ImportExcelTable th {
        min-width: 100px;
        padding: 5px;
        border-width: 1px;
        border-style: solid;
        border-color: #cccccc;
        background-color: #dedede;
        font-size: 10px;
    }

    .ImportExcelTable td {
        border-width: 1px;
        padding: 5px;
        /*
        padding-left: 2px;
        padding-right: 2px;
        padding-top: 2px;
        padding-bottom: 2px;
        */
        border-style: solid;
        border-color: #cccccc;
        background-color: #ffffff;
        font-size: 10px;
    }

    * {
        border-radius: 0;
    }
</style>
